import React, { useState, useEffect } from 'react';
import { useFamily } from '../context/FamilyContext';
import { subscribeToExpenses } from '@coparent/shared/src/services/expenseService';
import ExpenseInsights from '../components/expenses/ExpenseInsights';
import NotificationBell from '../components/notifications/NotificationBell';

const ExpenseInsightsPage = () => {
  const { familyId } = useFamily();
  const [expenses, setExpenses] = useState([]);

  useEffect(() => {
    if (!familyId) return;
    return subscribeToExpenses(familyId, setExpenses);
  }, [familyId]);

  return (
    <div className="animate-fade-in">
      <div className="flex items-center justify-between page-header">
        <div>
          <h1 className="page-title">Insights</h1>
          <p className="page-subtitle">Visualize your spending patterns</p>
        </div>
        <NotificationBell />
      </div>

      <ExpenseInsights expenses={expenses} />
    </div>
  );
};

export default ExpenseInsightsPage;
